import request from '@/request/request'
let baseURL =  global.$config.api.base_url + '/api/video-api'
let dataSever =  global.$config.api.base_url + '/api/data-server/data'
let monitorGBUrl =  global.$config.api.monitorGBUrl

// 获取视频列表
export function videoList(data) {
    return request({
        baseURL,
        url: '/video/list',
        method: 'post',
        data
    })
}
// 获取树形视频列表
export function videoListTree() {
    return request({
        baseURL,
        url: '/video/list-cascade',
        method: 'post',
        data: {}
    })
}
export function videoListCascadeDistrictPurge(data) {
    return request({
        baseURL,
        url: '/video/list-cascade-district-purge',
        method: 'post',
        data: data
    })
}
// 视频源保存接口
export function videoGetInfo(data) {
    return request({
        baseURL,
        url: '/video/get-info',
        method: 'post',
        data: data
    })
}
//Gb视频保存
export function GbVideoSave(data) {
    return request({
        baseURL,
        url: '/video-source/setting/save',
        method: 'post',
        data
    })
}
// Gb视频更新
export function GbVideoUpdate(data) {
    return request({
        baseURL,
        url: '/video-source/setting/update',
        method: 'post',
        data
    })
}
//RTSP视频保存
export function RTSPVideoSave(data) {
    return request({
        baseURL,
        url: '/video-source/raw/save',
        method: 'post',
        data
    })
}
// RTSP视频更新
export function RTSPVideoUpdate(data) {
    return request({
        baseURL,
        url: '/video-source/raw/update',
        method: 'post',
        data
    })
}
    /**
     * 视频组-列表
     */
export function getVideoGroup(data) {
    return request({
        baseURL:dataSever,
        url: '/resMonitorGroup/findListGroupName',
        method: 'post',
        data
    })
}
export function getVideoGroupDetail(data) {
    return request({
        baseURL:dataSever,
        url: '/resMonitorGroup/findPage',
        method: 'post',
        data
    })
}
/**
 * 视频组-新增or修改
 */
export function saveVideoGroup(data) {
    return request({
        baseURL: dataSever,
        url: '/resMonitorGroup/save',
        method: 'post',
        data
    })
}
/**
 * 视频组-删除
 */
export function delVideoGroup(data) {
    return request({
        baseURL: dataSever,
        url: '/resMonitorGroup/deleteByvideoGroupName',
        method: 'post',
        data
    })
}

   /**
     * 获取视频地址
     */
export function getStreamUrl(data) {
    return request({
        baseURL,
        url: '/video/getstreamurl',
        method: 'post',
        data
    })
}
 /**
     * 视频流转流
     */
 export function toHttpFlv(data, baseUrl = '') {
    if ('' == baseUrl) {
        baseUrl = monitorGBUrl
    }
    return http.request({
        baseUrl,
        url: '/video/toHttpFlv',
        method: 'post',
        data,
        timeout: 1000 * 60
    })
}